// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*atp-section:start*/
.atp-section {
  margin-top: 12px;
  padding-bottom: 80px;
}
.atp-section .row-container {
  display: flex;
  justify-content: space-between;
}

/*atp-section:end*/
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .atp-section .row-container {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/AppraisalToolPilot/AppraisalToolPilot.scss"],"names":[],"mappings":"AAAA,oBAAA;AACA;EACI,gBAAA;EACA,oBAAA;AACJ;AAAI;EACE,aAAA;EACA,8BAAA;AAEN;;AACE,kBAAA;AAEA;EAEI;IACI,eAAA;EAAR;AACF","sourcesContent":["/*atp-section:start*/ \r\n.atp-section{\r\n    margin-top: 12px;\r\n    padding-bottom: 80px;\r\n    .row-container{\r\n      display: flex;\r\n      justify-content: space-between;\r\n    }\r\n  }\r\n  /*atp-section:end*/ \r\n\r\n  @media only screen and (min-width: 0px) and (max-width: 768px) {\r\n    .atp-section{\r\n      .row-container{\r\n          flex-wrap: wrap;\r\n      }\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
